<div class="ribbon ribbon-{{type}}"><span class="" >{{ label }}</span></div>
